import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { DeleteProject$Params } from 'app/api/backend-connector/fn/projects/delete-project';
import { GetProject$Params } from 'app/api/backend-connector/fn/projects/get-project';
import { UpdateProject$Params } from 'app/api/backend-connector/fn/projects/update-project';
import { CreateProjectRequest } from 'app/api/backend-connector/models';
import { CurrentConfigurationApi, GlobalConfigurationsApi, ProjectsApi } from 'app/api/backend-connector/services';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  private readonly projectsApi = inject(ProjectsApi);
  private readonly currentConfigurationApi = inject(CurrentConfigurationApi);
  private readonly GlobalConfigurationsApi = inject(GlobalConfigurationsApi);

  listSession(params: Parameters<typeof ProjectsApi.prototype.listProjects>[0]) {
    return this.projectsApi.listProjects(params);
  }

  async createProject(params: CreateProjectRequest) {
    const body: CreateProjectRequest = {
      ...params,
    };
    return await lastValueFrom(this.projectsApi.createProject({ body: body }));
  }

  async editProject(params: UpdateProject$Params) {
    const body: UpdateProject$Params = {
      ...params,
    };
    await lastValueFrom(this.projectsApi.updateProject({ body: body.body, id: body.id }));
  }

  async deleteProject(params: DeleteProject$Params) {
    const body: DeleteProject$Params = {
      ...params,
    };
    await lastValueFrom(this.projectsApi.deleteProject({ id: body.id }));
  }

  async getProject(params: GetProject$Params) {
    return lastValueFrom(this.projectsApi.getProject({ id: params.id }));
  }

  async currentConfiguration() {
    const result = await lastValueFrom(this.currentConfigurationApi.getCurrentConfiguration());
    const defoult = result.data.imageCompression.default;
    localStorage.setItem('defaultCompression', defoult.toString());
    return result;
  }

  async updateCurrentConfiguration(newDefaultCompression: string) {
    const currentConfig = (await lastValueFrom(this.GlobalConfigurationsApi.listGlobalConfigurations())).items.find(
      (config) => config.isDefault === true,
    )!;
    const result = await lastValueFrom(
      this.GlobalConfigurationsApi.updateGlobalConfiguration({
        id: currentConfig.id,
        body: {
          ...currentConfig,
          data: {
            ...currentConfig.data,
            imageCompression: {
              ...currentConfig.data.imageCompression,
              default: newDefaultCompression,
            },
          },
        },
      }),
    );
    localStorage.setItem('defaultCompression', newDefaultCompression.toString());
    return result;
  }
}
